import React, { useEffect, useState, useRef } from "react";
import { ScrollArea, useToast } from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { CSVLink } from "react-csv";
import { thaiDate } from "../../util";
import constant, { statuses } from "../../constants";

export const ReportAdminCommission = () => {
  const downloadRef = useRef(null);
  const { callApi, configs } = Context();
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [loading, setLoading] = useState({
    users: false,
    orders: false,
    uploadSlip: false,
    allApprovedOrder: false,
    bundle: false,
  });
  const [orders, setOrders] = useState(false);
  const [dashboard, setDashboard] = useState(false);
  const [users, setUsers] = useState(false);
  const [uploadSlip, setUploadSlip] = useState(false);
  const [allApprovedOrder, setAllApproverOrder] = useState(false);
  const [coupon, setCoupon] = useState(false);
  const [bundle, setBundle] = useState(false);
  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getOrders = async () => {
    setLoading((prevState) => ({
      ...prevState,
      orders: true,
    }));

    setOrders(true);
    const orders = await callApi(
      "orders-getAll",
      {
        queries: [["createdByAdmin", true]],
        roundDate: selectedRoundDate,
        limit: 10000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true },
    );
    setOrders(orders);

    const obj = Object.values(
      orders.reduce((acc, order) => {
        if (acc[order.createdBy?.userId]) {
          acc[order.createdBy?.userId].orders.push(order);
        } else {
          acc[order.createdBy?.userId] = {
            admin: order.createdBy,
            orders: [order],
            uploadSlip: [],
            users: [],
          };
        }
        return acc;
      }, {}),
    );

    setDashboard(obj);
    // }

    setLoading((prevState) => ({
      ...prevState,
      orders: false,
    }));
  };

  const getCreateUser = async () => {
    setLoading((prevState) => ({
      ...prevState,
      users: true,
    }));
    setUsers(true);
    const users = await callApi(
      "users-getAll",
      {
        queries: [
          ["createdByAdmin", "==", true],
          ["createdAtRound", selectedRoundDate],
        ],
        roundDate: selectedRoundDate,
        limit: 10000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true },
    );
    setUsers(users);

    setLoading((prevState) => ({
      ...prevState,
      users: false,
    }));
  };

  const getCouponOrder = async () => {
    setLoading((prevState) => ({
      ...prevState,
      coupon: true,
    }));
    setCoupon(true);
    const couponOrder = await callApi(
      "coupons-getAllCouponOrders",
      {
        queries: [
          ["createdBy", "!=", false],
          ["status", statuses.APPROVE],
        ],
        roundDate: selectedRoundDate,
        limit: 10000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true },
    );
    setCoupon(couponOrder);

    setLoading((prevState) => ({
      ...prevState,
      coupon: false,
    }));
  };

  const getCouponBundleOrder = async () => {
    setLoading((prevState) => ({
      ...prevState,
      bundle: true,
    }));
    setBundle(true);
    const bundleOrder = await callApi(
      "coupons-getAllBundleOrders",
      {
        queries: [
          ["status", statuses.APPROVE],
          ["createdByAdmin", true],
        ],
        roundDate: selectedRoundDate,
        limit: 1000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true },
    );

    setBundle(bundleOrder);

    setLoading((prevState) => ({
      ...prevState,
      bundle: false,
    }));
  };

  const getUploadSlip = async () => {
    setLoading((prevState) => ({
      ...prevState,
      uploadSlip: true,
    }));
    setUploadSlip(true);
    const orders = await callApi(
      "orders-getAll",
      {
        queries: [["uploadSlipByAdmin", true]],
        roundDate: selectedRoundDate,
        limit: 10000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true },
    );
    setUploadSlip(orders);
    setLoading((prevState) => ({
      ...prevState,
      uploadSlip: false,
    }));

    // if (dashboard) {
    //   setDashboard((prevState) => {
    //     Object.values(
    //       orders.forEach((order) => {
    //         if (prevState[order.uploadSlipBy.userId]) {
    //           prevState[order.uploadSlipBy.userId].uploadSlip.push(order);
    //         } else {
    //           prevState[order.uploadSlipBy.userId] = {
    //             admin: order.uploadSlipBy,
    //             uploadSlip: [order],
    //             users: [],
    //             orders: [],
    //           };
    //         }
    //       })
    //     );
    //   });
    // } else {
    //   setDashboard(
    //     Object.values(
    //       orders.reduce((acc, order) => {
    //         if (acc[order.uploadSlipBy.userId]) {
    //           acc[order.uploadSlipBy?.userId].users.push(order);
    //         } else {
    //           acc[order.uploadSlipBy?.userId] = {
    //             admin: order.uploadSlipBy,
    //             users: [],
    //             uploadSlip: [order],
    //             orders: [],
    //           };
    //         }
    //         return acc;
    //       }, {})
    //     )
    //   );
    // }
  };

  const getApprovedOrder = async () => {
    setLoading((prevState) => ({
      ...prevState,
      allApprovedOrder: true,
    }));
    setAllApproverOrder(true);
    const allApprovedOrder = await callApi(
      "orders-getAll",
      {
        queries: [
          ["status", statuses.APPROVE],
          ["paymentChannel", "bank"],
        ],
        roundDate: selectedRoundDate,
        limit: 50000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true },
    );
    setAllApproverOrder(allApprovedOrder);
    setLoading((prevState) => ({
      ...prevState,
      allApprovedOrder: false,
    }));
  };

  const getData = async () => {
    setLoading({
      users: true,
      orders: true,
      uploadSlip: true,
      allApprovedOrder: true,
      button: true,
    });

    getOrders();
    getCreateUser();
    getUploadSlip();
    getApprovedOrder();
    getCouponOrder();
    getCouponBundleOrder();

    setLoading((prevState) => ({
      ...prevState,
      button: false,
    }));
  };

  const handleDownload = async (type) => {
    const csvBody = [];

    if (type === "users") {
      csvBody.push(["ลำดับ", "ผู้สร้างคำสั่งซื้อ", "สมัครสมาชิก"]);

      dashboard
        .sort((a, b) => b.orders.length - a.orders.length)
        .forEach((admin, index) =>
          csvBody.push([
            index + 1,
            admin.admin?.firstName + " " + admin?.admin?.lastName,
            admin.users.length,
          ]),
        );

      csvBody.push(["ยอดสมัครโดยแอดมิน", users.length, "คน"]);
      csvBody.push([
        "ลำดับ",
        "วัน-เวลาที่สมัคร",
        "รหัสผู้ใช้",
        "ชื่อ",
        "นามสกุล",
        "เบอร์โทรศัพท์",
        "สัญชาติ",
        "แอดมินผู้สร้าง",
      ]);

      users.forEach((user, index) =>
        csvBody.push([
          index + 1,
          new Date(user.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          }),
          `${user.id}`,

          user.firstName || "",
          user.lastName || "",
          `~${user.phone}` || "",
          user.nationality || "",
          user.createdBy.firstName + " " + user.createdBy.lastName,
        ]),
      );

      setCsvFileName(`รายงานแอดมินสมัตรสมาชิก_${thaiDate()}.csv`);
    } else if (type === "orders") {
      csvBody.push([
        "ลำดับ",
        "ผู้สร้างคำสั่งซื้อ",
        "ทั้งหมด",
        "สำเร็จ",
        "ยกเลิก",
      ]);

      dashboard
        .sort((a, b) => b.orders.length - a.orders.length)
        .forEach((admin, index) =>
          csvBody.push([
            index + 1,
            admin?.admin.firstName + " " + admin?.admin.lastName,

            admin.orders.length +
            " คำสั่งซื้อ " +
            "(" +
            admin.orders.reduce((acc, order) => {
              acc += order.size;
              return acc;
            }, 0) +
            " ใบ)",
            admin.orders.length +
            " ( " +
            +admin.orders
              .filter((order) => order.status === "approved")
              .reduce((acc, order) => {
                acc += order.size;
                return acc;
              }, 0) +
            " ใบ)",
            +admin.orders
              .filter((order) => order.status !== "approved")
              .reduce((acc, order) => {
                acc += order.size;
                return acc;
              }, 0),
          ]),
        );

      csvBody.push(["คำสั่งซื้อทั้งหมด", orders.length, "ออเดอร์"]);
      csvBody.push([
        "ลำดับ",
        "วัน-เวลาซื้อ",
        "รหัสคำสั่งซื้อ",
        "การจัดส่ง",
        "จำนวน (ใบ)",
        "ราคา",
        "สถานะ",
        "แอดมินผู้สร้าง",
      ]);

      orders.forEach((order, index) =>
        csvBody.push([
          index + 1,
          new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          }),
          `${order.shortId}`,

          order.deliverChannel,
          order.size,
          order.totalPrice,
          order.status,
          order.createdBy.firstName + " " + order.createdBy.lastName,
        ]),
      );

      setCsvFileName(`รายงานแอดมินสร้างคำสั่งซื้อ_${thaiDate()}.csv`);
    } else if (type === "uploadSlips") {
      csvBody.push([
        "ลำดับ",
        "ผู้สร้างคำสั่งซื้อ",
        "ทั้งหมด",
        "สำเร็จ",
        "ยกเลิก",
      ]);

      uploadSlip
        .reduce((acc, order, index) => {
          if (acc[order.uploadSlipBy.userId]) {
            acc[order.uploadSlipBy.userId].orders.push(order);
          } else {
            acc[order.uploadSlipBy.userId] = {
              uploadSlipBy: order.uploadSlipBy,
              orders: [order],
            };
          }

          return acc;
        }, [])
        .forEach((order, index) => {
          csvBody.push([
            index + 1,
            order.uploadSlipBy.firstName + " " + order.uploadSlipBy.lastName,
            order.orders.length,
            order.orders.filter((order) => order.status === "approved")?.length,
            order.orders.filter((order) => order.status !== "approved")?.length,
          ]);
        });

      csvBody.push(["คำสั่งซื้อทั้งหมด", orders.length, "ออเดอร์"]);
      csvBody.push([
        "ลำดับ",
        "วัน-เวลาซื้อ",
        "รหัสคำสั่งซื้อ",
        "สถานะ",
        "แอดมินผู้สร้าง",
      ]);

      uploadSlip.forEach((order, index) =>
        csvBody.push([
          index + 1,
          new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          }),
          `${order.shortId}`,

          order.status,
          order.uploadSlipBy.firstName + " " + order.uploadSlipBy.lastName,
        ]),
      );

      setCsvFileName(`รายงานแอดมินแนบสลิป_${thaiDate()}.csv`);
    } else if (type === "approvedOrders") {
      csvBody.push(["ลำดับ", "ผู้อนุมัติคำสั่งซื้อ", "ทั้งหมด"]);

      const admins = await allApprovedOrder.reduce((acc, order) => {
        if (acc[order.approverName]) {
          acc[order.approverName].orders.push(order);
        } else {
          acc[order.approverName] = {
            approverName: order.approverName,
            orders: [order],
          };
        }

        return acc;
      }, []);
      console.log(" admin", admins);
      await Object.values(admins).forEach((admin, index) => {
        csvBody.push([index + 1, admin.approverName, admin.orders.length]);
      });
      console.log("csvBody", csvBody);
      csvBody.push(["คำสั่งซื้อทั้งหมด", allApprovedOrder.length, "ออเดอร์"]);
      csvBody.push([
        "ลำดับ",
        "วัน-เวลาซื้อ",
        "รหัสคำสั่งซื้อ",

        "แอดมินผู้อนุมัติ",
      ]);

      allApprovedOrder.forEach((order, index) =>
        csvBody.push([
          index + 1,
          new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          }),
          `${order.shortId}`,
          order.approverName,
        ]),
      );

      setCsvFileName(`รายงานแอดมินอนุมัติคำสั่งซื้อ_${thaiDate()}.csv`);
    } else if (type === "coupon") {
      csvBody.push(["ลำดับ", "ผู้สร้างคำสั่งซื้อคูปอง", "ทั้งหมด"]);
      console.log("coupon", coupon);
      const admins = await coupon.reduce((acc, order) => {
        if (acc[order.createdBy.firstName]) {
          acc[order.createdBy.firstName].push(order.coupon.name);
        } else {
          acc[order.createdBy.firstName] = [order.coupon.name];
        }

        return acc;
      }, []);

      Object.entries(admins).forEach(([key, value]) => {
        const countSameName = value.reduce((acc2, name) => {
          if (acc2[name]) {
            acc2[name] += 1;
          } else {
            acc2[name] = 1;
          }
          return acc2;
        }, {});

        const arrOfCoupName = Object.entries(countSameName).map(
          ([k, v]) => `${k} (จำนวน ${v} ใบ)`,
        );

        csvBody.push([key, value.length, ...arrOfCoupName]);
      });

      console.log("csvBody", csvBody);
      csvBody.push(["คำสั่งซื้อทั้งหมด", coupon.length, "ออเดอร์"]);
      csvBody.push([
        "ลำดับ",
        "วัน-เวลาซื้อ",
        "รหัสคำสั่งซื้อ",
        "ประเภทคูปอง",
        "แอดมินผู้สร้างคำสั่งซื้อ",
      ]);

      coupon.forEach((order, index) =>
        csvBody.push([
          index + 1,
          new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          }),
          `${order.shortId}`,
          order.coupon.name,
          order.createdBy.firstName,
        ]),
      );

      setCsvFileName(`รายงานแอดมินสร้างคำสั่งซื้อคูปอง_${thaiDate()}.csv`);
    }

    setCsvData(csvBody);
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานแอดมิน"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
        <div className="p-3 border-b border-[#E5E7E9]">
          <p className="font-semibold ">ค้นหารางงานแอดมิน </p>
        </div>
        <div className="p-3 ">
          <p className="font-medium text-xs">งวด</p>
          <div>
            <select
              className="border w-full py-1 border-[#1a1b1c] rounded-lg font-semibold cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
              value={selectedRoundDate}
              onChange={(e) => setSelectedRoundDate(e.target.value)}
            >
              {configs.roundDates.map((roundDate) => (
                <option key={roundDate} value={roundDate}>
                  {roundDate}
                </option>
              ))}
            </select>
          </div>
          <div className="flex mt-3">
            <button
              disabled={loading.button}
              className="flex w-full items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
              onClick={() => {
                getData();
              }}
            >
              {loading.button ? (
                <Spinner className="w-3 h-3" />
              ) : (
                <MdPersonSearch className="text-white" />
              )}
              ค้นหา
            </button>
          </div>

          <div ref={downloadRef} className="hidden">
            <CSVLink
              data={csvData}
              filename={csvFileName}
              style={{ display: "none" }}
            >
              Download me
            </CSVLink>
          </div>
        </div>
      </div>

      {dashboard && (
        <div className="relative min-w-96 bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">สรุปคำสั่งซื้อโดยแอดมิน</p>
            <p className="text-xs font-semibold text-[#969797]">|</p>
            <p className="text-xs font-semibold text-[#969797]">
              {orders.length} ออเดอร์
            </p>
          </div>

          <ScrollArea className={`h-96`}>
            <Table>
              <TableHeader className={`bg-[#f2f3f5]`}>
                <TableRow>
                  <TableHead className="">ลำดับ</TableHead>
                  <TableHead className="">แอดมิน</TableHead>
                  {/* <TableHead className="text-center">สมัครสมาชิก</TableHead>
                  <TableHead className="text-center">แนบสลิป</TableHead> */}
                  <TableHead className={`text-center`}>
                    สร้างคำสั่งซื้อทั้งหมด
                  </TableHead>
                  <TableHead className={`text-center`}>สำเร็จ</TableHead>
                  <TableHead className={`text-center`}>ยกเลิก</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className={``}>
                {loading.dashboard ? (
                  <TableRow>
                    <TableCell className="font-medium" colSpan="7">
                      <Spinner className="w-3 h-3" />
                    </TableCell>
                  </TableRow>
                ) : dashboard ? (
                  dashboard
                    // .sort((a, b) => b.orders.length - a.orders.length)
                    .map((admin, index) => {
                      return (
                        <TableRow key={admin.admin.userId}>
                          <TableCell className="font-medium">
                            {index + 1}
                          </TableCell>
                          <TableCell className="font-medium">
                            {admin?.admin?.firstName +
                              " " +
                              admin?.admin?.lastName}
                          </TableCell>
                          {/* <TableCell className="font-semibold text-center">
                            {users?.filter(
                              (user) =>
                                user?.createdBy?.userId === admin?.admin?.userId
                            ).length || 0}{" "}
                            คน
                          </TableCell>
                          <TableCell className="font-semibold text-center">
                            {uploadSlip?.filter(
                              (order) =>
                                order?.uploadSlipBy?.userId ===
                                admin?.admin?.userId
                            ).length || 0}{" "}
                            คน
                          </TableCell> */}
                          <TableCell className={`text-center font-semibold`}>
                            {admin.orders?.length || 0}
                            {" คำสั่งซื้อ "}(
                            {admin.orders?.reduce((acc, order) => {
                              acc += order.size;
                              return acc;
                            }, 0) || 0}{" "}
                            ใบ)
                          </TableCell>
                          <TableCell className="font-semibold text-center text-green">
                            {admin.orders?.filter(
                              (order) => order.status === "approved",
                            ).length || 0}
                            {" คำสั่งซื้อ "}(
                            {admin.orders
                              ?.filter((order) => order.status === "approved")
                              .reduce((acc, order) => {
                                acc += order.size;
                                return acc;
                              }, 0) || 0}{" "}
                            ใบ)
                          </TableCell>
                          <TableCell className="font-semibold text-center text-[#c15b78]">
                            {admin.orders?.filter(
                              (order) => order.status !== "approved",
                            ).length || 0}
                            {" คำสั่งซื้อ "}(
                            {admin.orders
                              ?.filter((order) => order.status !== "approved")
                              .reduce((acc, order) => {
                                acc += order.size;
                                return acc;
                              }, 0) || 0}{" "}
                            ใบ)
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </ScrollArea>
        </div>
      )}

      {users && (
        <div className="relative min-w-96 bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">สมัครสมาชิกโดยแอดมิน</p>
            <p className="text-xs font-semibold text-[#969797]">|</p>
            <p className="text-xs font-semibold text-[#969797]">
              {loading.users ? <Spinner className="w-2 h-2 " /> : users.length}{" "}
              คน
            </p>

            <button
              disabled={!users.length}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={() => {
                handleDownload("users");
              }}
            >
              ดาวโหลด
            </button>
          </div>
          <ScrollArea className={`h-96`}>
            <Table>
              <TableHeader className={`bg-[#f2f3f5]`}>
                <TableRow>
                  <TableHead className="">ลำดับ</TableHead>
                  <TableHead className="">วันที่-เวลาที่สมัคร</TableHead>
                  <TableHead className={`text-center`}>รหัสผู้ใช้</TableHead>
                  <TableHead className={`text-center`}>ชื่อ</TableHead>
                  <TableHead className={`text-center`}>นามสกุล</TableHead>
                  <TableHead className={`text-center`}>เบอร์โทรศัพท์</TableHead>
                  <TableHead className={`text-center`}>สัญชาติ</TableHead>
                  <TableHead className={`text-right`}>แอดมินผู้สร้าง</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className={``}>
                {loading.users ? (
                  <TableRow className={``}>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-80 w-full flex justify-center items-center font-medium text-[#969797]">
                        <Spinner className="w-3 h-3" />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : users.length > 0 ? (
                  users.map((user, index) => {
                    return (
                      <TableRow key={user.shortId}>
                        <TableCell className="font-medium">
                          {index + 1}
                        </TableCell>
                        <TableCell className={`font-medium`}>
                          {new Date(user.createdAt).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            },
                          )}{" "}
                          น.
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {user.id}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {user.firstName}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {user.lastName}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {user.phone}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {user.nationality}
                        </TableCell>

                        <TableCell className="font-semibold text-right">
                          {user.createdBy?.userId +
                            " " +
                            user.createdBy?.firstName +
                            " " +
                            user.createdBy?.lastName +
                            " " +
                            user.createdBy?.phone}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </ScrollArea>
        </div>
      )}

      {orders && (
        <div className="relative min-w-96 bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">คำสั่งซื้อสลากโดยแอดมิน</p>
            <p className="text-xs font-semibold text-[#969797]">|</p>
            <p className="text-xs font-semibold text-[#969797]">
              {loading.orders ? <Spinner className="w-3 h-3" /> : orders.length}{" "}
              ออเดอร์
            </p>

            <button
              disabled={!orders.length}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={() => {
                handleDownload("orders");
              }}
            >
              ดาวโหลd
            </button>
          </div>
          <ScrollArea className={`h-96`}>
            <Table>
              <TableHeader className={`bg-[#f2f3f5]`}>
                <TableRow>
                  <TableHead className="">ลำดับ</TableHead>
                  <TableHead className="">วันที่-เวลาที่ซื้อ</TableHead>
                  <TableHead className={`text-center`}>
                    รหัสคำสั่งซื้อ
                  </TableHead>
                  <TableHead className={`text-center`}>การจัดส่ง</TableHead>
                  <TableHead className={`text-center`}>จำนวน (ใบ)</TableHead>
                  <TableHead className={`text-center`}>ราคา</TableHead>
                  <TableHead className={`text-center`}>สถานะ</TableHead>
                  <TableHead className={`text-right`}>แอดมินผู้สร้าง</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className={``}>
                {loading.orders ? (
                  <TableRow className={``}>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-80 w-full flex justify-center items-center font-medium text-[#969797]">
                        <Spinner className="w-3 h-3" />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : orders.length > 0 ? (
                  orders.map((order, index) => {
                    return (
                      <TableRow key={order.shortId}>
                        <TableCell className="font-medium">
                          {index + 1}
                        </TableCell>
                        <TableCell className={`font-medium`}>
                          {new Date(order.createdAt).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            },
                          )}{" "}
                          น.
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`bg-blue text-white font-semibold py-1 rounded-md cursor-pointer
                            `}
                            onClick={() =>
                              window.open(`/orders/${order.id}`, "_blank")
                            }
                          >
                            {order.shortId}
                          </div>
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {order.deliverChannel}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {order.size}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {order.totalPrice}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`${order.status === "approved"
                                ? `bg-green`
                                : `bg-[#c15b78]`
                              } text-white font-semibold py-1 rounded-md
                            `}
                          >
                            {constant.statusesTranslate[order.status]}
                          </div>
                        </TableCell>
                        <TableCell className="font-semibold text-right">
                          {order.createdBy?.userId +
                            " " +
                            order.createdBy?.firstName +
                            " " +
                            order.createdBy?.lastName +
                            " " +
                            order.createdBy?.phone}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </ScrollArea>
        </div>
      )}

      {uploadSlip && (
        <div className="relative min-w-96 bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">อัปโหลดสลิปโดยแอดมิน</p>
            <p className="text-xs font-semibold text-[#969797]">|</p>
            <p className="text-xs font-semibold text-[#969797]">
              {loading.uploadSlip ? (
                <Spinner className="w-3 h-3" />
              ) : (
                uploadSlip.length
              )}{" "}
              ออเดอร์
            </p>

            <button
              disabled={!uploadSlip.length}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={() => {
                handleDownload("uploadSlips");
              }}
            >
              ดาวโหลด
            </button>
          </div>
          <ScrollArea className={`h-96`}>
            <Table>
              <TableHeader className={`bg-[#f2f3f5]`}>
                <TableRow>
                  <TableHead className="">ลำดับ</TableHead>
                  <TableHead className="">วันที่-เวลาที่ซื้อ</TableHead>
                  <TableHead className={`text-center`}>
                    รหัสคำสั่งซื้อ
                  </TableHead>

                  <TableHead className={`text-center`}>สถานะ</TableHead>
                  <TableHead className={`text-right`}>แอดมินผู้สร้าง</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className={``}>
                {loading.uploadSlip ? (
                  <TableRow className={``}>
                    <TableCell className="" colSpan="5">
                      <div className="min-h-80 w-full flex justify-center items-center font-medium text-[#969797]">
                        <Spinner className="w-3 h-3" />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : uploadSlip.length > 0 ? (
                  uploadSlip.map((order, index) => {
                    return (
                      <TableRow key={order.shortId}>
                        <TableCell className="font-medium">
                          {index + 1}
                        </TableCell>
                        <TableCell className={`font-medium`}>
                          {new Date(order.createdAt).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            },
                          )}{" "}
                          น.
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`bg-blue text-white font-semibold py-1 rounded-md cursor-pointer
                            `}
                            onClick={() =>
                              window.open(`/orders/${order.id}`, "_blank")
                            }
                          >
                            {order.shortId}
                          </div>
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`${order.status === "approved"
                                ? `bg-green`
                                : `bg-[#c15b78]`
                              } text-white font-semibold py-1 rounded-md
                            `}
                          >
                            {constant.statusesTranslate[order.status]}
                          </div>
                        </TableCell>
                        <TableCell className="font-semibold text-right">
                          {order.uploadSlipBy?.userId +
                            " " +
                            order.uploadSlipBy?.firstName +
                            " " +
                            order.uploadSlipBy?.lastName +
                            " " +
                            order.uploadSlipBy?.phone}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </ScrollArea>
        </div>
      )}
      {allApprovedOrder && (
        <div className="relative min-w-96 bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">แอดมินอนุมัติออเดอร์</p>
            <p className="text-xs font-semibold text-[#969797]">|</p>
            <p className="text-xs font-semibold text-[#969797]">
              {loading.allApprovedOrder ? (
                <Spinner className="w-3 h-3" />
              ) : (
                allApprovedOrder.length.toLocaleString()
              )}{" "}
              ออเดอร์
            </p>

            <button
              disabled={!allApprovedOrder.length}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={() => {
                handleDownload("approvedOrders");
              }}
            >
              ดาวโหลด
            </button>
          </div>
          <ScrollArea className={`h-96`}>
            <Table>
              <TableHeader className={`bg-[#f2f3f5]`}>
                <TableRow>
                  <TableHead className="">ลำดับ</TableHead>
                  <TableHead className="">วันที่-เวลาที่ซื้อ</TableHead>
                  <TableHead className={`text-center`}>
                    รหัสคำสั่งซื้อ
                  </TableHead>

                  <TableHead className={`text-center`}>สถานะ</TableHead>
                  <TableHead className={`text-right`}>
                    แอดมินผู้อนุมัติ
                  </TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className={``}>
                {loading.allApprovedOrder ? (
                  <TableRow className={``}>
                    <TableCell className="" colSpan="5">
                      <div className="min-h-80 w-full flex justify-center items-center font-medium text-[#969797]">
                        <Spinner className="w-3 h-3" />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : allApprovedOrder.length > 0 ? (
                  allApprovedOrder.map((order, index) => {
                    return (
                      <TableRow key={order.shortId}>
                        <TableCell className="font-medium">
                          {index + 1}
                        </TableCell>
                        <TableCell className={`font-medium`}>
                          {new Date(order.createdAt).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            },
                          )}{" "}
                          น.
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`bg-blue text-white font-semibold py-1 rounded-md cursor-pointer
                            `}
                            onClick={() =>
                              window.open(`/orders/${order.id}`, "_blank")
                            }
                          >
                            {order.shortId}
                          </div>
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`${order.status === "approved"
                                ? `bg-green`
                                : `bg-[#c15b78]`
                              } text-white font-semibold py-1 rounded-md
                            `}
                          >
                            {constant.statusesTranslate[order.status]}
                          </div>
                        </TableCell>
                        <TableCell className="font-semibold text-right">
                          {order.approverName}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </ScrollArea>
        </div>
      )}
      {bundle && (
        <div className="relative min-w-96 bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">
              แอดมินสร้างคำสั่งซื้อคูปอง (แบบชุด)
            </p>
            <p className="text-xs font-semibold text-[#969797]">|</p>
            <p className="text-xs font-semibold text-[#969797]">
              {loading.bundle ? (
                <Spinner className="w-3 h-3" />
              ) : (
                bundle.length.toLocaleString()
              )}{" "}
              ออเดอร์
            </p>

            <button
              disabled={!bundle.length}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={() => {
                handleDownload("coupon");
              }}
            >
              ดาวโหลด
            </button>
          </div>
          <ScrollArea className={`h-96`}>
            <Table>
              <TableHeader className={`bg-[#f2f3f5]`}>
                <TableRow>
                  <TableHead className="">ลำดับ</TableHead>
                  <TableHead className="">วันที่-เวลาที่ซื้อ</TableHead>
                  <TableHead className={`text-center`}>
                    รหัสคำสั่งซื้อ
                  </TableHead>

                  <TableHead className={`text-center`}>ประเภทคูปอง</TableHead>
                  <TableHead className={`text-center`}>สถานะ</TableHead>
                  <TableHead className={`text-right`}>แอดมินผู้สร้าง</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className={``}>
                {loading.bundle ? (
                  <TableRow className={``}>
                    <TableCell className="" colSpan="6 d">
                      <div className="min-h-80 w-full flex justify-center items-center font-medium text-[#969797]">
                        <Spinner className="w-3 h-3" />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : bundle.length > 0 ? (
                  bundle.map((order, index) => {
                    return (
                      <TableRow key={order.shortId}>
                        <TableCell className="font-medium">
                          {index + 1}
                        </TableCell>
                        <TableCell className={`font-medium`}>
                          {new Date(order.createdAt).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            },
                          )}{" "}
                          น.
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`bg-blue text-white font-semibold py-1 rounded-md cursor-pointer
                            `}
                            onClick={() =>
                              window.open(`/coupon/${order.id}`, "_blank")
                            }
                          >
                            {order.shortId}
                          </div>
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {order.bundle.name}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`${order.status === "approved"
                                ? `bg-green`
                                : `bg-[#c15b78]`
                              } text-white font-semibold py-1 rounded-md
                            `}
                          >
                            {constant.statusesTranslate[order.status]}
                          </div>
                        </TableCell>
                        <TableCell className="font-semibold text-right">
                          #
                          {order.createdBy.userId +
                            " " +
                            order.createdBy.firstName}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </ScrollArea>
        </div>
      )}
      {coupon && (
        <div className="relative min-w-96 bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">แอดมินสร้างคำสั่งซื้อคูปอง</p>
            <p className="text-xs font-semibold text-[#969797]">|</p>
            <p className="text-xs font-semibold text-[#969797]">
              {loading.coupon ? (
                <Spinner className="w-3 h-3" />
              ) : (
                coupon.length.toLocaleString()
              )}{" "}
              ออเดอร์
            </p>

            <button
              disabled={!coupon.length}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={() => {
                handleDownload("coupon");
              }}
            >
              ดาวโหลด
            </button>
          </div>
          <ScrollArea className={`h-96`}>
            <Table>
              <TableHeader className={`bg-[#f2f3f5]`}>
                <TableRow>
                  <TableHead className="">ลำดับ</TableHead>
                  <TableHead className="">วันที่-เวลาที่ซื้อ</TableHead>
                  <TableHead className={`text-center`}>
                    รหัสคำสั่งซื้อ
                  </TableHead>

                  <TableHead className={`text-center`}>ประเภทคูปอง</TableHead>
                  <TableHead className={`text-center`}>สถานะ</TableHead>
                  <TableHead className={`text-right`}>แอดมินผู้สร้าง</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className={``}>
                {loading.coupon ? (
                  <TableRow className={``}>
                    <TableCell className="" colSpan="6 d">
                      <div className="min-h-80 w-full flex justify-center items-center font-medium text-[#969797]">
                        <Spinner className="w-3 h-3" />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : coupon.length > 0 ? (
                  coupon.map((order, index) => {
                    return (
                      <TableRow key={order.shortId}>
                        <TableCell className="font-medium">
                          {index + 1}
                        </TableCell>
                        <TableCell className={`font-medium`}>
                          {new Date(order.createdAt).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            },
                          )}{" "}
                          น.
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`bg-blue text-white font-semibold py-1 rounded-md cursor-pointer
                            `}
                            onClick={() =>
                              window.open(`/coupon/${order.id}`, "_blank")
                            }
                          >
                            {order.shortId}
                          </div>
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          {order.coupon.name}
                        </TableCell>
                        <TableCell className="font-medium text-center">
                          <div
                            className={`${order.status === "approved"
                                ? `bg-green`
                                : `bg-[#c15b78]`
                              } text-white font-semibold py-1 rounded-md
                            `}
                          >
                            {constant.statusesTranslate[order.status]}
                          </div>
                        </TableCell>
                        <TableCell className="font-semibold text-right">
                          {order.createdBy.firstName}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell className="" colSpan="8">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </ScrollArea>
        </div>
      )}
    </div>
  );
};
